<template>
  <div id="app">
    <div v-show="loading">
      Loading...
    </div>
    <div v-show="!loading">
      <header id="luxbar" class="luxbar-fixed">
        <input type="checkbox" class="luxbar-checkbox" id="luxbar-checkbox" v-model="luxbarChecked"/>
        <div class="luxbar-menu luxbar-menu-right luxbar-menu-dark">
          <ul class="luxbar-navigation">
            <li class="luxbar-header">
              <span v-on:click="luxbarChecked = false" v-if="this.$route.name === 'home'"><a href="#home" class="luxbar-brand" v-smooth-scroll><img class="logo" width="220px" src="./assets/img/logo.svg"></a></span>
              <span v-on:click="luxbarChecked = false" v-else><router-link :to="{ name: 'home', params: { value: 'home' }}" class="luxbar-brand"><img class="logo" width="220px" src="./assets/img/logo.svg"></router-link></span>
              <label class="luxbar-hamburger luxbar-hamburger-doublespin"
                     id="luxbar-hamburger" for="luxbar-checkbox"> <span></span> </label>
            </li>
            <li v-on:click="luxbarChecked = false" v-if="this.$route.name === 'recruit'" class="luxbar-item"><a href="#recruit" v-smooth-scroll>RECRUIT</a></li>
            <li v-on:click="luxbarChecked = false" class="luxbar-item" v-else><router-link :to="{ name: 'recruit', params: { value: 'recruit' }}">RECRUIT</router-link></li>
            <li v-on:click="luxbarChecked = false" v-if="this.$route.name === 'company'" class="luxbar-item"><a href="#company" v-smooth-scroll>COMPANY</a></li>
            <li v-on:click="luxbarChecked = false" class="luxbar-item" v-else><router-link :to="{ name: 'company', params: { value: 'company' }}">COMPANY</router-link></li>
            <li v-on:click="luxbarChecked = false" v-if="this.$route.name === 'contact'" class="luxbar-item"><a href="#contact" v-smooth-scroll>CONTACT</a></li>
            <li v-on:click="luxbarChecked = false" class="luxbar-item" v-else><router-link :to="{ name: 'contact', params: { value: 'contact' }}">CONTACT</router-link></li>
          </ul>
        </div>
      </header>
      <router-view/>
      <footer id="footer">
        <div class="container">
          <div class="footersitemap">
            <div>
              <h4 class="footersitemap-heading">SERVICE</h4>
              <ul class="list-line">
                <li v-if="this.$route.name === 'home'"><a href="#finance" v-smooth-scroll>証券（リテール）システム開発支援</a></li>
                <li v-else><router-link :to="{ name: 'home', params: { value: 'finance' }}">証券（リテール）システム開発支援</router-link></li>
                <li v-if="this.$route.name === 'home'"><a href="#web-create" v-smooth-scroll>Webサイト開発</a></li>
                <li v-else><router-link :to="{ name: 'home', params: { value: 'web-create' }}">Webサイト開発</router-link></li>
              </ul>
            </div>
            <div>
              <h4 class="footersitemap-heading">RECRUIT</h4>
              <ul class="list-line">
                <li v-if="this.$route.name === 'recruit'"><a href="#job-description" v-smooth-scroll>仕事内容</a></li>
                <li v-else><router-link :to="{ name: 'recruit', params: { value: 'job-description' }}">仕事内容</router-link></li>
                <li v-if="this.$route.name === 'recruit'"><a href="#desired-image" v-smooth-scroll>求める人物像</a></li>
                <li v-else><router-link :to="{ name: 'recruit', params: { value: 'desired-image' }}">求める人物像</router-link></li>
                <li v-if="this.$route.name === 'recruit'"><a href="#application-requirements" v-smooth-scroll>募集要項</a></li>
                <li v-else><router-link :to="{ name: 'recruit', params: { value: 'application-requirements' }}">募集要項</router-link></li>
                <li v-if="this.$route.name === 'recruit'"><a href="#flow-of-adoption" v-smooth-scroll>採用までの流れ</a></li>
                <li v-else><router-link :to="{ name: 'recruit', params: { value: 'flow-of-adoption' }}">採用までの流れ</router-link></li>
              </ul>
            </div>
            <div>
              <h4 class="footersitemap-heading">COMPANY</h4>
              <ul class="list-line">
                <li v-if="this.$route.name === 'company'"><a href="#company" v-smooth-scroll>代表あいさつ</a></li>
                <li v-else><router-link :to="{ name: 'company', params: { value: 'company' }}">代表あいさつ</router-link></li>
                <li v-if="this.$route.name === 'company'"><a href="#company-prof-title" v-smooth-scroll>会社概要</a></li>
                <li v-else><router-link :to="{ name: 'company', params: { value: 'company-prof-title' }}">会社概要</router-link></li>
              </ul>
            </div>
            <div>
              <ul>
                <li v-if="this.$route.name === 'privacy'"><a href="#privacy" v-smooth-scroll>プライバシーポリシー</a></li>
                <li v-else><router-link :to="{ name: 'privacy', params: { value: 'privacy' }}">プライバシーポリシー</router-link></li>
                <li v-if="this.$route.name === 'contact'"><a href="#contact" v-smooth-scroll>お問い合わせ</a></li>
                <li v-else><router-link :to="{ name: 'contact', params: { value: 'contact' }}">お問い合わせ</router-link></li>
              </ul>
            </div>
          </div>
          <div class="footersitemap">
            <img width="260px" src="./assets/img/logo.svg">
            <div>
              <span class="br">株式会社ビットハイブ TEL: 03-6811-7716</span>
              <span class="br">101-0052 東京都千代田区神田小川町1-9</span>
              <span class="br">川上ビル3F</span>
            </div>
            <h4 class="footersitemap-heading">MOTION LOGO</h4>
            <div class="motion-logo">
              <video controls width="260" height="149">
                <source src="./assets/audio/motionlogo.mp4">
                <p>動画を再生するには、videoタグをサポートしたブラウザが必要です。</p>
              </video>
            </div>
          </div>
        </div>
        <div id="copyright"><font-awesome-icon icon="copyright" /> Bithive Japan Inc.</div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data: function () {
    return {
      loading: true,
      luxbarChecked: false
    }
  },
  mounted () {
    setTimeout(() => {
      this.loading = false
    }, 2000)
  }
}
</script>

<style lang="scss">
@import "~luxbar/scss/luxbar.scss";
@import "/assets/style/global.scss";
body {
  margin: 0;
}
.br::before {
  content: "\A";
  white-space: pre;
}
#app {
  font-family: $font-family;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#luxbar {
  .logo {
    padding: 9px 0 0 0
  }
  .luxbar-item {
    font-size: 15px;
    font-weight: 700;
    letter-spacing: .05em;
  }
}
#footer {
  padding: 50px 0;
  background-color: #212121;
  color: #fff;
  .container {
    width: 100%;
    padding: 0 20px 30px;
    margin: 0 auto;
    text-align: left;
    display: flex;
    display: -ms-flexbox; /* IE10 */
    flex-wrap: wrap;
    -ms-flex-wrap: wrap; /* IE10 */
    .footersitemap {
      width: 50%;
      padding: 10px;
      div {
        margin: 0 0 30px;
        .list-line {
          border-left: 1px solid #9a9a9a;
        }
        ul {
          padding: 0 0 0 18px;
          list-style: none;
          li {
            font-size: 12px;
            line-height: 2.2em;
            letter-spacing: .07rem;
          }
        }
      }
      .motion-logo {
        padding: 18px 0;
      }
      span {
        font-size: 12px;
        line-height: 2.2em;
        letter-spacing: .07rem;
      }
      a {
        display: block;
        color: inherit;
        opacity: 1;
        -webkit-transition: opacity .25s ease;
        transition: opacity .25s ease;
        text-decoration: none;
      }
    }
    @media screen and (max-width: 960px) {
      .footersitemap {
        width: 100%;
      }
    }
    .footersitemap-heading {
      margin: 0;
      font-size: 18px;
      color: #9a9a9a;
      letter-spacing: .5em;
    }
  }
  #copyright {
    font-size: 1rem;
    text-align: center;
  }
}
*, *:before, *:after {
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue